import React from 'react';
import OrderPickups from './OrderPickups';
import { Button } from 'reactstrap';
import moment from 'moment';
import {Aux} from "../../constants";
import {PickupNoteSummary} from "../Pickups/PickupNoteSummary";
import store from '../../store';
import {loadProjectedRunFields} from "../../actions/runActions";
import {getCollectionAction, getRunFlag, getRunFlagBadgeClass, getRunFlagIcon, getRunTypeCardStyle} from '../../utils/collectionTypes';


const RunSummaryView = (props) => {
  let { run, onRunRefresh, isListView, isMapView, handleViewMode, isAdmin,
    onFinishOrderRun, resetMap, onEnterReOrderRun, onLoadDriverLocations, isEditView,
    scrollToComponent, driverLocations, showEdit, onPrintPdf, offset, onChangeOffset,
    handleViewCompletedRun, viewCompletedRun, 
  } = props;
  return (
    <div className="card-block" style={getRunTypeCardStyle(run.truckCollectionTypeCode)}>
      <h5 className="card-title">
        {run.isComplete && <span className="badge badge-success">Run Complete</span>}
        {!run.isComplete && <span>
          <span className="badge badge-warning">Run Incomplete</span>&nbsp;
          {isAdmin && showEdit && <a href="#"
             onClick={(e) => { e.preventDefault();
             handleViewMode('edit', true);}}>Edit...</a>}
        </span>}
          <span className={getRunFlagBadgeClass(run.truckCollectionTypeCode) + ' ml-1'}><i className={getRunFlagIcon(run.truckCollectionTypeCode)}/> {getRunFlag(run.truckCollectionTypeCode)}</span>
        {onRunRefresh &&
          <span className="pull-right" style={{marginLeft: '10px'}}> <a href="#" onClick={onRunRefresh}><i className="fa fa-refresh">&nbsp;</i></a></span>}
        {onPrintPdf && isAdmin &&
          <Aux>
            <span className="pull-right"> <a href="#" onClick={onPrintPdf}><i className="fa fa-print">&nbsp;</i></a></span>
            <input className="pull-right form-control" title={'Offset'} style={{width:'50px', marginTop:'-6px', marginRight:'5px'}} type={'number'} value={offset} onChange={onChangeOffset} />
          </Aux>}
      </h5>
      <h6>{run.runDate}<br />
          { run.dateModified != '0001-01-01T00:00:00' &&
          <span className="text-muted" style={{fontSize:'small'}}>
        <i className="fa fa-save"/>&nbsp;{moment(run.dateModified).format('ddd, Do, LT')}</span>}
        </h6>
      <h4 style={{marginTop: '5px', marginBottom:'5px'}} className="card-subtitle">{run.regionsVisited} - {run.truckName}</h4>
      <h6>{run.driverFullName}</h6>
      <p className="card-text"><i className="fa fa-shopping-cart" />&nbsp; { `${parseFloat(run.totalLitres).toFixed(0)} L to be ${getCollectionAction(run.truckCollectionTypeCode)}`}</p>
      <p className="card-text"><i className="fa fa-battery-full" />&nbsp; { `${parseFloat(run.totalEstimatedLitresPickedUp).toFixed(2)} L ${getCollectionAction(run.truckCollectionTypeCode)}`}</p>
      <p className="card-text"><i className="fa fa-tachometer" />&nbsp; { `${run.pickupsComplete}/${run.pickupsToComplete}`} locations complete</p>
      { (run.pickupsToComplete-run.pickupsComplete == 0) && run.isBaseCheckedIn && !run.isBaseCheckedOut && <p className="card-text text-danger"><i className="fa fa-warning" /> Must check out of final location</p> }
      <div>
        <span><strong>View modes&nbsp;</strong></span>
        <label className="switch switch-text switch-pill switch-primary">
          <input type="checkbox"
                 checked={isListView}
                 className="switch-input"
                 onChange={(e)=> handleViewMode('list', e.target.checked)}
                 name="check-listView"
          />
          <span className="switch-label" data-on="List" data-off="List" />
          <span className="switch-handle" />
        </label>&nbsp;
        <label className="switch switch-text switch-pill switch-primary">
          <input type="checkbox"
                 checked={isMapView}
                 className="switch-input"
                 onChange={(e)=> handleViewMode('map', e.target.checked)}
                 name="check-mapView"
          />
          <span className="switch-label" data-on="Map" data-off="Map" />
          <span className="switch-handle" />
        </label>
      </div>        
      {isAdmin &&
      <div className="row">
        <div className="col-md-12">
          {showEdit && (onFinishOrderRun || run.isComplete) &&
          <OrderPickups
            run={run}
            onFinishOrderRun={(run) => {
              onFinishOrderRun(run);
              setTimeout(()=> resetMap(), 500);
            }}
            onEnterReOrderRun={onEnterReOrderRun}
            isEditView={isEditView}
            showEdit={true}
            loadProjectedRunFields={({runId}) => store.dispatch(loadProjectedRunFields({runId}))}
            viewCompletedRun={viewCompletedRun}
            handleViewCompletedRun={handleViewCompletedRun}
          /> }

          { run.hasDriverLocations &&
            run.driverLocations.length == 0 &&
            onLoadDriverLocations &&
          <Button
            color="info"
            onClick={()=> {
              handleViewMode('map', false);
              handleViewMode('list', false);
              onLoadDriverLocations();
              scrollToComponent(driverLocations);
            }}
            style={{float: 'left', marginRight: '10px'}}
          >Load driver locations</Button>
          }
        </div>
      </div>
      }
      <div className={"mt-1"}>&nbsp;</div>
        { run.pickups.map(p => <PickupNoteSummary pickup={p} key={p.id} />) }
      
    </div>
    
    );

};

export default RunSummaryView;